<template>
  <div>
    <NavBar></NavBar>
    <ImageDimension @sendProfileTubeImgInfo="getTubeImgInfo" @sendLengthValue="getTubeLength"></ImageDimension>
    <RawMatSpeTube :getImgInfo="tubeImgInfo" @sendKiloPrice="getTubeKiloPrice"
      @sendMainTubeTypeIdAndWeigthMeter="getMainTubeTypeIdAndWeigthMeter"></RawMatSpeTube>
    <ServicesTube :getTubeImageInfo="tubeImgInfo" :getWeigthMeter="tubeWeigthMeter" :getMainTubeType="tubeTypeMainId"
      @sendTotalServices="getTubeTotalServices"></ServicesTube>
    <TubePrice :getKiloPrice="kiloPrice" :getWeigthMeter="tubeWeigthMeter" :getLengthValue="tubeLength"
      :getTotalSevices="tubeTotalServices"></TubePrice>
  </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import ImageDimension from "@/components/GeneralComponents/ImgDimensionTubPerfComponent.vue";
import RawMatSpeTube from "@/components/TubeQuote/TubeRawMatSpecificationComponent.vue";
import ServicesTube from "@/components/TubeQuote/TubeServicesQuoteComponent.vue";
import TubePrice from "@/components/GeneralComponents/ProfileAndTubePriceComponent.vue";
export default {
  components: {
    NavBar,
    ImageDimension,
    RawMatSpeTube,
    ServicesTube,
    TubePrice,
  },
  data() {
    return {
      tubeLength: 0,
      tubeImgInfo: [],
      tubeTypeMainId: 0,
      kiloPrice: 0,
      tubeWeigthMeter: 0,
      tubeTotalServices: 0,
    }
  },
  methods: {
    getTubeLength(data) {
      this.tubeLength = data;
      // console.log("Longitud final:" + this.tubeLength);
    },
    getTubeImgInfo(data) {
      this.tubeImgInfo = data;
      // console.log(this.tubeImgInfo);
    },
    getTubeKiloPrice(data) {
      this.kiloPrice = data;
      // console.log(this.kiloPrice);
    },
    getMainTubeTypeIdAndWeigthMeter(data) {
      // console.log(data);
      this.tubeTypeMainId = data.tubeTypeId;
      this.tubeWeigthMeter = data.weightMeter;
      // console.log("Id" + this.tubeTypeMainId);
      // console.log("Peso" + this.tubeWeigthMeter);
    },
    getTubeTotalServices(data) {
      this.tubeTotalServices = data;
      // console.log(this.tubeTotalServices);
    },
  },
};
</script>
<style scoped></style>